import React, { useEffect, useRef } from "react";
import { motion, useAnimation, useInView } from "framer-motion";

export default function Network({ dimension = "150" }) {
  const controls = useAnimation();
  const iconRef = useRef(null);
  const isInView = useInView(iconRef, { once: true });
  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
  }, [isInView]);

  const iconPath = {
    hidden: {
      pathLength: 0,
      stroke: "var(--secondary)",
    },
    visible: {
      pathLength: 1,
      stroke: [
        "var(--secondary)",
        "var(--secondary)",
        "var(--secondary)",
        "var(--secondary)",
        "var(--primary)",
      ],
      transition: {
        duration: 2,
        ease: "easeInOut",
      },
      transitionEnd: {
        fill: "var(--primary)",
      },
    },
  };
  return (
    <motion.svg
      width={dimension}
      height={dimension}
      viewBox="0 0 500 500"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={iconRef}
      initial="hidden"
      animate={controls}
    >
      <motion.path
        variants={iconPath}
        strokeWidth="2"
        d="M386.366 114.823L386.596 114.453L386.26 114.175C373.26 103.428 364.959 87.1827 364.959 69.04C364.959 36.7615 391.22 10.5 423.499 10.5C455.777 10.5 482.039 36.7614 482.039 69.0453C482.039 101.318 455.777 127.58 423.499 127.58C415.049 127.58 407.033 125.74 399.766 122.503L399.367 122.326L399.138 122.697L327.815 237.849L327.582 238.224L327.926 238.501C342.662 250.379 352.119 268.543 352.119 288.891C352.119 302.978 347.542 315.991 339.867 326.63L339.607 326.989L339.933 327.29L383.309 367.402L383.621 367.691L383.956 367.428C392.321 360.886 402.811 356.953 414.219 356.953C441.383 356.953 463.479 379.055 463.479 406.213C463.479 433.372 441.377 455.473 414.219 455.473C387.06 455.473 364.959 433.377 364.959 406.213C364.959 396.172 367.994 386.833 373.174 379.034L373.409 378.679L373.097 378.39L329.763 338.321L329.439 338.021L329.101 338.306C317.827 347.839 303.279 353.617 287.392 353.617C267.971 353.617 250.569 344.982 238.691 331.388L238.401 331.056L238.035 331.303L129.656 404.476L129.294 404.721L129.488 405.113C133.354 412.919 135.585 421.676 135.585 430.96C135.585 463.239 109.324 489.5 77.0453 489.5C44.7669 489.5 18.5053 463.239 18.5 430.955C18.5 398.682 44.7614 372.42 77.04 372.42C94.3408 372.42 109.861 380.007 120.588 391.976L120.879 392.301L121.24 392.057L229.613 318.889L229.98 318.641L229.779 318.247C225.263 309.418 222.665 299.464 222.665 288.891C222.665 278.774 225.067 269.221 229.228 260.678L229.422 260.28L229.051 260.039L171.925 222.983L171.563 222.748L171.277 223.073C161.106 234.667 146.227 242.033 129.632 242.033C99.0603 242.033 74.1907 217.153 74.1907 186.581C74.1907 156.009 99.0655 131.135 129.637 131.135C160.209 131.135 185.084 156.009 185.084 186.581C185.084 194.867 183.203 202.705 179.93 209.774L179.748 210.167L180.112 210.404L237.184 247.422L237.555 247.663L237.839 247.324C249.722 233.181 267.515 224.159 287.392 224.159C297.044 224.159 306.178 226.344 314.42 230.15L314.821 230.335L315.054 229.959L386.366 114.823ZM89.1853 186.592C89.1853 208.895 107.329 227.033 129.632 227.033C151.935 227.033 170.079 208.895 170.079 186.592C170.079 164.289 151.935 146.145 129.632 146.145C107.329 146.145 89.1853 164.289 89.1853 186.592ZM33.5053 430.96C33.5053 454.969 53.0359 474.5 77.0453 474.5C101.055 474.5 120.585 454.969 120.585 430.96C120.585 406.956 101.055 387.425 77.0453 387.425C53.0359 387.425 33.5053 406.956 33.5053 430.96ZM414.219 440.473C433.114 440.473 448.479 425.103 448.479 406.213C448.479 387.324 433.108 371.953 414.219 371.953C395.329 371.953 379.959 387.324 379.959 406.213C379.959 425.103 395.324 440.473 414.219 440.473ZM287.392 338.612C314.809 338.612 337.119 316.308 337.119 288.891C337.119 261.468 314.809 239.164 287.392 239.164C259.975 239.164 237.665 261.468 237.665 288.891C237.665 316.303 259.975 338.612 287.392 338.612ZM423.499 25.5C399.489 25.5 379.959 45.0305 379.959 69.04C379.959 93.0496 399.489 112.575 423.499 112.575C447.508 112.575 467.039 93.0442 467.039 69.04C467.039 45.0305 447.508 25.5 423.499 25.5Z"
      />
    </motion.svg>
  );
}
